module.exports = __webpack_public_path__ + "static/media/default-3.fa5a76cd.svg";